module.exports = __webpack_public_path__ + "epilace_1_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/epilace_1_before_tn.jpg
// module id = 1412
// module chunks = 0